function e(t) {
  switch (typeof t) {
    case "string":
      return t || void 0;
    case "number":
      return String(t);
    default:
      return;
  }
}
export {
  e as getTitleAttribute
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/naive/attribute.js
// module id = 1627
// module chunks = 67